import React, { useState } from 'react';
import { FieldError, useFormContext } from 'react-hook-form';
import get from 'lodash/get';
import { Input } from '../../../../CommonComponents/OPL/Input/Input';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { SpaceProps } from '../../../../theme/styledProps';
import { EditableField } from '../../components/EditableField/EditableField';
import { DraftAccountDTO } from '../../AccountOpening.meta';

interface Props extends SpaceProps {
  isReview?: boolean;
  fieldName: string;
  draftAccount: DraftAccountDTO;
}

export const Email: React.FC<Props> = ({ fieldName, isReview, draftAccount, ...rest }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const [isEditing, setIsEditing] = useState(!isReview);

  if (!isEditing) {
    return (
      <EditableField onEdit={() => setIsEditing(true)}>
        {get(draftAccount, fieldName)}
      </EditableField>
    );
  }

  return (
    <Box {...rest}>
      <Input
        {...register(fieldName)}
        label={isReview ? undefined : 'Email Address'}
        leftIcon="far fa-envelope"
        type="text"
        placeholder="you@samplecapital.com"
        formVariant={get(errors, fieldName) ? 'error' : undefined}
        helperText={(get(errors, fieldName) as FieldError | undefined)?.message}
        aria-label="Email Address"
        autoComplete="email"
        maxLength={256}
      />
    </Box>
  );
};
